/*
 * Country / language localization selector.
 *
 * One shared custom element used by BOTH the header (snippets/header-country-selector.liquid)
 * and the footer (sections/footer.liquid). Previously each place shipped its own
 * near-identical implementation under a different tag name to avoid the
 * "already defined" collision; this file is the single source of truth.
 *
 * DOM contract (identical in header and footer markup):
 *   <localization-selector>
 *     <form ...>
 *       <button> ... </button>                       toggles the panel
 *       <div class="disclosure__list-wrapper" hidden> panel
 *         <a data-value="..."> ... </a>               option -> writes input + submits
 *       </div>
 *       <input name="country_code"|"locale_code">      the value the form posts
 *     </form>
 *   </localization-selector>
 *
 * Behavior: click the button to toggle the panel; choosing an option writes its
 * value into the hidden input and submits the form so Shopify re-renders in that
 * market/locale. The panel closes on Escape or a click outside the element.
 */
if (!customElements.get('localization-selector')) {
  customElements.define(
    'localization-selector',
    class LocalizationSelector extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        this.panel = this.querySelector('.disclosure__list-wrapper');
        this.input = this.querySelector('input[name="country_code"], input[name="locale_code"]');
        if (!this.button || !this.panel) return;

        this.button.addEventListener('click', this.toggle.bind(this));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.querySelectorAll('a[data-value]').forEach((item) =>
          item.addEventListener('click', this.onSelect.bind(this))
        );
        document.addEventListener('click', this.onOutsideClick.bind(this));
      }

      open() {
        this.panel.removeAttribute('hidden');
        this.button.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.panel.setAttribute('hidden', '');
        this.button.setAttribute('aria-expanded', 'false');
      }

      toggle() {
        if (this.panel.hasAttribute('hidden')) this.open();
        else this.close();
      }

      onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.close();
        this.button.focus();
      }

      onSelect(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        if (this.input) this.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      onOutsideClick(event) {
        if (!this.contains(event.target)) this.close();
      }
    }
  );
}
